import React from "react";
import MailingListForm from "./MailingListForm";

/**
 * <MailingListFooterCTA /> — permanent signup section rendered just above
 * the site Footer. Same form / same webhook as the popup; only the `source`
 * field changes ("footer_signup").
 */
export default function MailingListFooterCTA() {
  return (
    <section
      data-testid="mailing-list-footer-cta"
      className="relative py-20 md:py-28 border-t border-white/5"
    >
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true"
        style={{
          background: "radial-gradient(ellipse at top, rgba(212,175,55,0.06), transparent 65%)",
        }}
      />
      <div className="relative max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="text-[11px] uppercase tracking-[0.28em] text-gold/85">
            Stay In The Loop
          </span>
          <h2 className="mt-4 font-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-tight">
            Get insights, case studies &amp;{" "}
            <span className="bk-gold-text italic">offers</span> — straight to your inbox.
          </h2>
          <p className="mt-5 text-white/65 leading-relaxed">
            Join the Bow Tie Kreative list. No spam, just the good stuff. Unsubscribe anytime —
            and you can opt in for text-message alerts too.
          </p>
        </div>

        <MailingListForm
          source="footer_signup"
          variant="footer"
          testidPrefix="mailing-list-footer-form"
        />
      </div>
    </section>
  );
}
